import GeneralUtil from './GeneralUtil';
import AiBase from 'aiBase';

const root = {}
export default root

Object.entries(GeneralUtil).forEach(([k,f])=>root[k] = f);
const transformMath = ({x,y})=>({x: 9 - x, y: y + 9});//19路数学坐标系转AI坐标，临时
const transformAi = ({x,y})=>({x: 9 - x, y: y - 9});//AI坐标转 19路数学坐标系，临时
const initAiCoordinate = coordinate=>{
    const aiCoordinate = coordinate.map(transformMath),ai = new AiBase(19);
    aiCoordinate.forEach(({x,y},i)=>ai.addOnePoint(x,y,i&1));
    return {ai,aiCoordinate}
}

Object.assign(root,{ transformMath , transformAi , initAiCoordinate })
const copyText = root.copyText = async function (text, alertText = '复制成功!') {
    const success = await  navigator.clipboard.writeText(text);
    success && this.$message({ message: alertText, type: 'success' });
    return;


    var tag = document.createElement('input');
    tag.setAttribute('id', 'cp_hgz_input');
    tag.value = text;
    document.getElementsByTagName('body')[0].appendChild(tag);
    document.getElementById('cp_hgz_input').select();
    document.execCommand('copy');
    document.getElementById('cp_hgz_input').remove();

    this.$message({ message: alertText, type: 'success' });
}


root.encodeIp = function(v){
    return Array(4).fill(true).map(c=>{var vv=v&0xff;v=v>>8;return vv}).reverse().join('.');
}

root.decodeIp = function(ip){
    return ip.split('.').map(v=>parseInt(v)).reduce((r,v)=>(r*256)+v,0) ;
}

root.hint = function(message){
    this.$message({ message, type: 'success' });
}

root.confirm = function (title, message) {
    return new Promise(res => {
        this.$confirm(message, title, {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(v => res(true)).catch(v => res(false))
    });
}

root.formSubmit = function (formData, url, method = 'post', json = true) {
    return new Promise((res, rej) => {
        const req = new XMLHttpRequest()
        req.onreadystatechange = function () {
            if (req.readyState === 4) {
                // console.log(req.responseText);
                // if (response.code === '200')
                res(json ? JSON.parse(req.responseText) : req.responseText);
                // else
                //     rej('request err!',req);
            }
        }
        req.open(method, url, true)
        req.send(formData)
    });
}

const parseJ5tSingleData = root.parseJ5tSingleData = function( str){
    const code = ( str || '' ).trim() .split('|||').shift().trim();
    return code && code.split(';').filter(v=>v).map(v=>v.split('_').map(vv=>parseInt(vv))).map(([x,y])=>({x,y})) || [];
}

const j5tSingleDataToStrCode = root.j5tSingleDataToStrCode = function (moves){
    return moves.map( ({x,y})=>[x,y].join('_') ).join(';');
}

const gKey = root.gKey = function ({x,y}){ return [x,y].join('_') }


const parseCoordinateCode = root.parseCoordinateCode = function(coordinateData){
    return coordinateData && coordinateData.split(';').map(v=>v.split('_').map(vv=>parseInt(vv))).map(([x,y])=>({x,y})) || []
}


const circleToStrCodeEle = root.circleToStrCodeEle = ({color,x,y,size,type})=>[color,gKey({x,y}),size,type].join(':');
const hotInfoToStrCode = root.hotInfoToStrCode = hotInfo=>{
    const {
        currentHotPart:part=-1,optimistic=false,minConnectLine=2,opts=['3','s4'],
        maxStrength=32,minStrengthValue=50 ,
    } = hotInfo || {} ;
    const optsStr = opts.join(',');
    return [part,optimistic,minConnectLine,optsStr,maxStrength,minStrengthValue].join(';');
}
const lineToStrCode = root.lineToStrCode = ({x,y,deg,color,width})=>[ gKey({x,y}) , deg , color , width ].join(':')
const letterToStrCode = root.letterToStrCode = ({x,y,value,color,selected})=>[ gKey({x,y}) , value,color,selected ].join(':')
const generateCoordinate = root.generateCoordinate = function (para){
    const { coordinate,circleList=[],hotInfo,lines=[],letters=[],attack1Part=-1 } = para
    const coordinateCode = para.coordinateCode || j5tSingleDataToStrCode(coordinate);
    const circleCode = para.circleCode || circleList.map( circleToStrCodeEle ).join(';')
    const hotInfoCode = para.hotInfoCode || hotInfoToStrCode( hotInfo );
    const lineCode = para.lineCode || lines.map( lineToStrCode ).join(';');
    const letterCode = para.letterCode || letters.map( letterToStrCode ).join(';');
    return [coordinateCode,circleCode,hotInfoCode,attack1Part,letterCode,lineCode].join('|||')
}

root.parseCoordinate = function (data=''){

    const [coordinateData,circleData,hotPartData,attack1PartData,lettersData,linessData] = data.split('|||');
    const coordinate = parseCoordinateCode(coordinateData);
    const circleList = ( circleData || '' )
        .split(';')
        .filter(v=>v).map(v=>v.split(':'))
        .map(([color,coordinate,size,type])=>
            ({color,...parseCoordinateCode(coordinate).find(v=>1),size:Number(size),type}));
    const circleDic = circleList.reduce( (r,o)=>(r[ gKey(o) ] = o,r) , {} );
    // .reduce((r,[k,v])=>(r[k]=parseCoordinateFunc(v),r),{})
    const hotInfo = hotPartData && parseHotInfo(hotPartData) || null;
    const attack1Part = !attack1PartData || !attack1PartData.trim() || isNaN(attack1PartData) ? -1 : Number(attack1PartData)
    const letters = ( lettersData || '' ).split(';').filter(v=>v).map(v=>v.split(':'))
        .map(([coordinate,value,color,selected])=>
            [...parseCoordinateCode(coordinate),value,color||'',Number(selected) && true || false]);
    const lines = ( linessData || '' ).split(';').filter(v=>v).map(v=>v.split(':'))
        .map(([coordinate,deg,color,width])=>
            ({...parseCoordinateCode(coordinate).find(v=>1),deg,color,width:parseInt(width)}));
    const lineDic = lines.reduce( (r,o)=>(r[ gKey(o) ] = o,r) , {} );
    return {
        coordinate,
        circleList,circleDic,
        hotInfo,
        attack1Part,
        letters,
        lines,lineDic,
    };
}

root.copyYixinData = function (v,hint){
    const half = 19 >> 1 , moves = Array.isArray( v ) && v || parseJ5tSingleData( v  )
    const coors = moves
        .map(({x,y})=>[ String.fromCharCode( 97 + half + x ) ,half+y+1].join(''))
        .join('');
    this.copyText(coors,hint || '复制成功，可粘贴到弈心中运算');
    // return coors;
}

root.getWindowSize = function (){
    const currentWindowWidth = Math.min(window.screen.width, document.body.clientWidth);
    const currentWindowHeight = window.innerHeight;//Math.max(window.screen.height, document.body.clientHeight);
    return { currentWindowWidth , currentWindowHeight }
}



